import DistributionBarChart from './DistributionBarChart';
export default DistributionBarChart;



// WEBPACK FOOTER //
// ./src/components/DistributionBarChart/index.js